import React, { createContext, useState, useContext } from 'react'
import { getItem, setItem, removeItem, authLocalStorage } from '../config/localStorage'

const authContext = createContext()

function ProvideAuth({ children }) {
    let auth = useProvideAuth()

    const authInfoLocal = getItem(authLocalStorage)
    if (authInfoLocal) {
        const userInfo = JSON.parse(authInfoLocal)
        auth.user = userInfo
    }

    return <authContext.Provider value={auth}>{children}</authContext.Provider>
}

function useAuth() {
    return useContext(authContext)
}

function useProvideAuth() {
    const [user, setUser] = useState(null)

    const signin = async value => {
        setUser(value)
        const storageItem = JSON.stringify(value)
        await setItem(authLocalStorage, storageItem)
    }

    const signout = async () => {
        setUser(null)
        await removeItem(authLocalStorage)
    }

    return {
        user,
        signin,
        signout,
    }
}

export { ProvideAuth, useAuth, useProvideAuth }
